import { render, staticRenderFns } from "./refund-goods.vue?vue&type=template&id=105f1202&scoped=true&"
import script from "./refund-goods.vue?vue&type=script&lang=js&"
export * from "./refund-goods.vue?vue&type=script&lang=js&"
import style0 from "./refund-goods.vue?vue&type=style&index=0&id=105f1202&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f1202",
  null
  
)

export default component.exports